import FormattedMessage from 'I18n/components/FormattedMessage';
import { MISSING_SCOPE, RESTRICTED_BY_SOURCE_APP } from 'automation-ui-permissions/feature-permissions/constants/DisabledReasons';
import * as WorkflowManagementFeatureKeys from 'automation-ui-permissions/feature-permissions/constants/WorkflowManagementFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const DISABLED_FEATURE_MESSAGES = {
  [WorkflowManagementFeatureKeys.ASSIGN_TEAM]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.assignTeam.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.assignTeam.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.CLONE]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.clone.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.clone.restrictedBySourceApp"
    })
  },
  // TODO (JB): Is this  a view only scope? Need to check with platform
  [WorkflowManagementFeatureKeys.COMMENT]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    })
  },
  [WorkflowManagementFeatureKeys.DELETE]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.delete.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.delete.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.DISABLE]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.disable.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.disable.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.EDIT_ACTIONS]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.edit-actions.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.edit-actions.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.EDIT_DESCRIPTION]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    })
  },
  [WorkflowManagementFeatureKeys.EDIT_ENROLLMENT]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.edit-enrollment.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.edit-enrollment.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.EDIT_REENROLLMENT]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.edit-reenrollment.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.edit-reenrollment.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.EDIT_SETTINGS]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    })
  },
  [WorkflowManagementFeatureKeys.ENABLE]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.enable.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.enable.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.EXPORT]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    })
  },
  [WorkflowManagementFeatureKeys.MANUAL_ENROLLMENT]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.manual-enrollment.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.manual-enrollment.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.MOVE]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.move.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.move.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.RESTORE]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.restore.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.restore.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.EDIT_GOAL]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.edit-goal.missingScope"
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-permissions.disabledFeatures.edit-goal.restrictedBySourceApp"
    })
  },
  [WorkflowManagementFeatureKeys.TEST]: {
    [MISSING_SCOPE]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    }),
    [RESTRICTED_BY_SOURCE_APP]: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ""
    })
  }
};
export const getDisabledFeatureMessage = ({
  feature,
  disabledReason
}) => {
  const disabledReasonsForFeature = DISABLED_FEATURE_MESSAGES[feature];
  if (disabledReason && disabledReasonsForFeature) {
    return disabledReasonsForFeature[disabledReason] || null;
  }
  return null;
};